import { z } from 'zod';

import { FREE_TEXT_FIELD_TITLE_MAX_LENGTH } from '@/constants';

interface FreeTextFieldFormSchemaMessages {
  titleMaxLengthError: string;
  titleRequiredError: string;
}

export const createFreeTextFieldFormSchema = ({
  titleMaxLengthError,
  titleRequiredError,
}: FreeTextFieldFormSchemaMessages) =>
  z.object({
    content: z.string().nullable(),
    id: z.string(),
    title: z
      .string()
      .trim()
      .min(1, titleRequiredError)
      .max(FREE_TEXT_FIELD_TITLE_MAX_LENGTH, titleMaxLengthError),
  });
